import data from './components/Quiz/data'

export type Answers = `a` | `b` | `c` | `d` | `e` | `f`

export interface DataResult {
  score: number
  response?: string
}

export interface Result {
  act: DataResult
  adapt: DataResult
  collect: DataResult
  synthesize: DataResult
  total: number
  rating: string
}

export type ResultType = Omit<Result, `total` | `rating`>

export const formatTrackingResults = (raw: Result) => {
  const { act, adapt, collect, synthesize, total, rating } = raw
  return {
    actResponse: act.response,
    actScore: act.score,
    adaptResponse: adapt.response,
    adaptScore: adapt.score,
    cdmRating: rating,
    collectResponse: collect.response,
    collectScore: collect.score,
    synthesizeResponse: synthesize.response,
    synthesizeScore: synthesize.score,
    totalScore: total,
  }
}

const calculateResults = (answers: Answers[]) => {
  const defaults = {
    act: { score: 0 },
    adapt: { score: 0 },
    collect: { score: 0 },
    synthesize: { score: 0 },
    total: 0,
    rating: ``,
  } as Result

  const result = data.reduce((acc, type, index) => {
    const response = type.answers[answers[index]]
    acc[`${type.key as keyof ResultType}`].score = response?.score || 0
    acc[`${type.key as keyof ResultType}`].response = response?.title || ``
    acc.total += response?.score || 0

    return acc
  }, defaults)

  if (result.total <= 3) {
    result.rating = `getting-started`
  } else if (result.total <= 7) {
    result.rating = `developing`
  } else if (result.total <= 11) {
    result.rating = `leading`
  } else if (result.total > 11) {
    result.rating = `visionary`
  }

  return result
}

export default calculateResults
